// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__8K9wg","errorLogs":"styles_errorLogs__b-lUP"};